export function isValidEmail(email) {
  const re = /^[^\s@]+@[^\s@]+\.[^\s@]{2,63}$/;
  return re.test(String(email).toLowerCase());
}

export function isValidPhone(phone) {
  const cleaned = String(phone ?? "").trim();
  const re = /^\+\d{9,}$/;
  return re.test(cleaned);
}

export function normalizeCpf(cpf = "") {
  return String(cpf).replace(/\D/g, "");
}

export function isValidCpf(cpf) {
  const cleaned = normalizeCpf(cpf);
  return /^\d{11}$/.test(cleaned);
}

export function isValidCpfSearch(cpf) {
  return /^\d{0,11}$/.test(cpf);
}

export const CLIENT_DOCUMENT_TYPES = {
  CPF: "CPF",
  CNPJ: "CNPJ",
};

export function normalizeClientDocument(value = "") {
  return String(value).replace(/\D/g, "");
}

export function isValidClientDocument(value, type) {
  const normalized = normalizeClientDocument(value);
  if (type === CLIENT_DOCUMENT_TYPES.CPF) return normalized.length === 11;
  if (type === CLIENT_DOCUMENT_TYPES.CNPJ) return normalized.length === 14;
  return false;
}

export function formatClientDocument(value, type) {
  const digits = normalizeClientDocument(value).slice(
    0,
    type === CLIENT_DOCUMENT_TYPES.CNPJ ? 14 : 11,
  );

  if (type === CLIENT_DOCUMENT_TYPES.CNPJ) {
    return digits
      .replace(/^(\d{2})(\d)/, "$1.$2")
      .replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3")
      .replace(/\.(\d{3})(\d)/, ".$1/$2")
      .replace(/(\d{4})(\d)/, "$1-$2");
  }

  return digits
    .replace(/^(\d{3})(\d)/, "$1.$2")
    .replace(/^(\d{3})\.(\d{3})(\d)/, "$1.$2.$3")
    .replace(/\.(\d{3})(\d)/, ".$1-$2");
}

// export function isPasswordValid(password) {
//   const re = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9]).{8,}$/;
//   return re.test(password);
// }

export const getPasswordRules = (password = "") => {
  const hasAllowedSpecialChar = /[\^$*.[\]{}()?"!@#%&/\\,><':;|_~`+=-]/.test(password);

  return {
    minLength: password.length >= 8,
    hasUppercase: /[A-Z]/.test(password),
    hasLowercase: /[a-z]/.test(password),
    hasNumber: /\d/.test(password),
    hasSpecialChar: hasAllowedSpecialChar,
    noLeadingOrTrailingSpace: password === password.trim(),
  };
};

export const isPasswordValid = (password = "") => Object.values(getPasswordRules(password)).every(Boolean);
